<template>
    <div>
        <transition name="fade">
            <div v-show="flgSuccess"
                 class="alert alert-success">
                <div class="d-flex justify-content-between align-items-center">
                    <div>{{ successMessage }}</div>
                    <div class="btn-close" @click="reset">
                        <span>&times;</span>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="fade">
            <div v-show="flgDanger"
                 class="alert alert-danger">
                <div class="d-flex justify-content-between align-items-center">
                    <div>{{ dangerMessage }}</div>
                    <div class="btn-close" @click="reset">
                        <span>&times;</span>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="fade">
            <div v-show="flgWarning"
                 class="alert alert-warning">
                <div class="d-flex justify-content-between align-items-center">
                    <div>{{ warningMessage }}</div>
                    <div class="btn-close" @click="reset">
                        <span>&times;</span>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="fade">
            <div v-show="flgInfo"
                 class="alert alert-info">
                <div class="d-flex justify-content-between align-items-center">
                    <div>{{ infoMessage }}</div>
                    <div class="btn-close" @click="reset">
                        <span>&times;</span>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default  {
        data: function() {
            return {
                flgSuccess: false,
                flgDanger: false,
                flgWarning: false,
                flgInfo: false,
                successMessage: '',
                dangerMessage: '',
                warningMessage: '',
                infoMessage: '',
                successMessageDefault: '保存しました。',
                dangerMessageDefault: '内容に不備があります。ご確認ください。',
                timer: null,
            };
        },

        created: function() {
            bus.$on('alert-success', this.success)
            bus.$on('alert-danger', this.danger)
            bus.$on('alert-warning', this.warning)
            bus.$on('alert-info', this.info)
        },

        beforeDestroy: function() {
            bus.$off('alert-success')
            bus.$off('alert-danger')
            bus.$off('alert-warning')
            bus.$off('alert-info')
        },

        methods: {
            /**
             * 成功アラート表示
             *
             * @param {string} message
             * @param {number} milliseconds
             */
            success: function (message, milliseconds) {
                this.reset()

                this.flgSuccess = true
                this.successMessage = ''
                this.successMessage = message || this.successMessageDefault
                bus.$emit('toggle-display-other-alert', true)

                this.resetDelay(milliseconds)
            },

            /**
             * 失敗アラート表示
             *
             * @param {string} message
             * @param {number} milliseconds
             */
            danger: function (message, milliseconds) {
                this.reset()

                this.flgDanger = true
                this.dangerMessage = ''
                this.dangerMessage = message || this.dangerMessageDefault
                bus.$emit('toggle-display-other-alert', true)

                this.resetDelay(milliseconds)
            },

            /**
             * 警告アラート表示
             *
             * @param {string} message
             * @param {number} milliseconds
             */
            warning: function (message, milliseconds) {
                this.reset()

                this.flgWarning = true
                this.warningMessage = ''
                this.warningMessage = message
                bus.$emit('toggle-display-other-alert', true)

                this.resetDelay(milliseconds)
            },

            /**
             * 情報アラート表示
             *
             * @param {string} message
             * @param {number} milliseconds
             */
            info: function (message, milliseconds) {
                this.reset()

                this.flgInfo = true
                this.infoMessage = ''
                this.infoMessage = message
                bus.$emit('toggle-display-other-alert', true)

                this.resetDelay(milliseconds)
            },

            /**
             * フラグリセット
             */
            reset: function() {
                this.flgSuccess = false
                this.flgDanger = false
                this.flgWarning = false
                this.flgInfo = false
                bus.$emit('toggle-display-other-alert', false)
            },

            /**
             * 遅延フラグリセット
             *
             * @param {number} milliseconds
             */
            resetDelay: function (milliseconds = 3000) {
                if (Number.isInteger(milliseconds)) {
                    clearTimeout(this.timer)
                    this.timer = setTimeout(() => this.reset(), milliseconds)
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    .alert {
        position: fixed;
        left: 50%;
        top: 20px;
        z-index: 9999;
        width: 80vw;
        transform: translate( -50%, 0 );
        opacity: 1;
    }

    .btn-close {
        position: relative;
        width: 20px;
        height: 20px;
        min-width: 20px;
        color: #fff;
        line-height: 20px;
        font-weight: bold;
        text-align: center;
        border-radius: 50%;
        cursor: pointer;
    }

    .alert-success {
        .btn-close {
            background: #155724;
        }
    }

    .alert-danger {
        .btn-close {
            background: #721c24;
        }
    }

    .alert-warning {
        .btn-close {
            background: #856404;
        }
    }

    .alert-info {
        .btn-close {
            background: #0c5460;
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
